(function (window, document) {
  'use strict';

  /*
   * The artwork-rights notice on custom-upload products. After Upload-Lift
   * stores the customer's upload, this shows one line under the upload field
   * (and under the image-choice question when that is showing): adding to
   * cart confirms the customer owns the artwork or has permission to print
   * it. It never holds Add to cart. While an upload is present, every
   * purchase form carries the hidden line-item property _artwork_rights, so
   * the order keeps a record that the notice was shown.
   */

  var core = window.EpicArtworkRightsCore;
  if (!core) {
    if (window.console && typeof window.console.error === 'function') {
      window.console.error('[Epic artwork rights] Core module did not load.');
    }
    return;
  }

  var bootstrap = window.__epicArtworkRightsBootstrap = window.__epicArtworkRightsBootstrap || {};
  bootstrap.events = Array.isArray(bootstrap.events) ? bootstrap.events : [];
  var PANEL_SELECTOR = '[data-epic-artwork-rights]';
  var IMAGE_CHOICE_SELECTOR = '[data-epic-image-enhancement]';

  function allPanels() {
    return Array.prototype.slice.call(document.querySelectorAll(PANEL_SELECTOR));
  }

  function panelForTarget(target) {
    var panels = allPanels();
    var root = target && target.closest ? target.closest('[data-upload-lift]') : null;
    var productId = root ? root.getAttribute('data-upload-lift') : '';
    for (var index = 0; index < panels.length; index += 1) {
      if (productId && panels[index].getAttribute('data-product-id') === String(productId)) return panels[index];
    }
    return panels.length === 1 ? panels[0] : null;
  }

  function isPurchaseForm(form) {
    return Boolean(form && /\/cart\/add(?:\.js)?(?:\?|$)/.test(form.getAttribute('action') || form.action || '') &&
      !form.classList.contains('js-instalments-form'));
  }

  // Symmetry renders a sticky Add to cart form beside the main one, so the
  // property rides on every purchase form.
  function purchaseForms() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var result = [];
    for (var index = 0; index < forms.length; index += 1) {
      if (isPurchaseForm(forms[index])) result.push(forms[index]);
    }
    return result;
  }

  function ensureInput(form) {
    var input = form.querySelector('input[data-epic-ar-property]');
    if (input) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + core.PROPERTY_NAME + ']';
    input.value = core.PROPERTY_VALUE;
    input.setAttribute('data-epic-ar-property', '');
    input.disabled = true;
    form.appendChild(input);
    return input;
  }

  function render(panel) {
    var shown = Boolean(panel.__epicUploadUrl);
    panel.hidden = !shown;
    var forms = purchaseForms();
    for (var index = 0; index < forms.length; index += 1) {
      var input = ensureInput(forms[index]);
      input.value = core.PROPERTY_VALUE;
      input.disabled = !shown;
    }
  }

  function placePanel(panel, target) {
    // After Upload-Lift's outer root, so its own re-renders never remove us,
    // and after the image-choice question when it sits there.
    var root = target && target.closest
      ? (target.closest('[data-upload-lift]') || target.closest('[data-upload-field]'))
      : null;
    if (!root || !root.parentNode || panel.contains(root)) return;
    var anchor = root;
    var next = anchor.nextElementSibling;
    while (next && next !== panel && next.matches && next.matches(IMAGE_CHOICE_SELECTOR)) {
      anchor = next;
      next = anchor.nextElementSibling;
    }
    if (anchor.nextElementSibling === panel) return;
    anchor.parentNode.insertBefore(panel, anchor.nextSibling);
  }

  function handleAdded(target, detail) {
    if (!core.isMainFile(detail)) return;
    var panel = panelForTarget(target);
    if (!panel) return;
    placePanel(panel, target);
    panel.__epicUploadUrl = String(detail.url);
    render(panel);
  }

  function handleRemoved(target, detail) {
    if (!core.isMainFile(detail)) return;
    var panel = panelForTarget(target);
    if (!panel) return;
    panel.__epicUploadUrl = core.afterRemove(panel.__epicUploadUrl, detail.url);
    render(panel);
  }

  function handleEvent(record) {
    if (record.type === 'upload:added') handleAdded(record.target, record.detail);
    else if (record.type === 'upload:removed') handleRemoved(record.target, record.detail);
  }

  function installListeners() {
    if (bootstrap.listenersInstalled) return;
    bootstrap.listenersInstalled = true;
    // The inline bootstrap queued any events that fired before this loaded.
    bootstrap.handle = handleEvent;
    var queued = bootstrap.events;
    bootstrap.events = [];
    for (var index = 0; index < queued.length; index += 1) handleEvent(queued[index]);
    if (!bootstrap.captureInstalled) {
      bootstrap.captureInstalled = true;
      ['upload:added', 'upload:removed'].forEach(function (type) {
        window.addEventListener(type, function (event) {
          handleEvent({ type: type, target: event.target, detail: event.detail });
        }, true);
      });
    }
  }

  // Upload-Lift can restore a previous upload before this file loads, and
  // its upload:added may then fire before any listener exists. It always
  // leaves a properties[uploaded_image] input in the form, so pick that up.
  function adoptExistingUploads() {
    var inputs = document.querySelectorAll('input[name="properties[uploaded_image]"]');
    for (var index = 0; index < inputs.length; index += 1) {
      var input = inputs[index];
      var url = String(input.value || '').trim();
      if (!/^https:\/\//.test(url)) continue;
      var panel = panelForTarget(input);
      if (!panel || panel.__epicUploadUrl) continue;
      handleAdded(input, { url: url, meta: {} });
    }
  }

  installListeners();
  var panels = allPanels();
  for (var index = 0; index < panels.length; index += 1) render(panels[index]);
  adoptExistingUploads();
  window.addEventListener('load', adoptExistingUploads);
})(window, document);
